// SVG icons
import TIFitAll from '@material-icons/svg/svg/fit_screen/outline.svg?component'
import TINavPoints from '@material-icons/svg/svg/place/outline.svg?component'
import TIZones from '@material-icons/svg/svg/pentagon/outline.svg?component'
import TITaxis from '@material-icons/svg/svg/local_taxi/outline.svg?component'
import TIMap from '@material-icons/svg/svg/map/outline.svg?component'
import TIMyGPS from '@material-icons/svg/svg/my_location/outline.svg?component'
import TIArea from '@material-icons/svg/svg/pentagon/outline.svg?component'
import TIStreet from '@material-icons/svg/svg/polyline/outline.svg?component'
import TIHouse from '@material-icons/svg/svg/apartment/outline.svg?component'
import TIPOI from '@material-icons/svg/svg/location_on/outline.svg?component'
import TIPOIInternal from '@material-icons/svg/svg/pin_drop/outline.svg?component'
import TIMenu from '@material-icons/svg/svg/menu/outline.svg?component'
import TIMore from '@material-icons/svg/svg/more_vert/outline.svg?component'
import TISettings from '@material-icons/svg/svg/settings/outline.svg?component'
import TILogout from '@material-icons/svg/svg/logout/outline.svg?component'
import TISearch from '@material-icons/svg/svg/search/outline.svg?component'
import TIClose from '@material-icons/svg/svg/close/outline.svg?component'
import TICheck from '@material-icons/svg/svg/check/outline.svg?component'
import TIChevronLeft from '@material-icons/svg/svg/chevron_left/outline.svg?component'
import TIChevronRight from '@material-icons/svg/svg/chevron_right/outline.svg?component'
import TIExpandLess from '@material-icons/svg/svg/expand_less/outline.svg?component'
import TIExpandMore from '@material-icons/svg/svg/expand_more/outline.svg?component'
import TIRefresh from '@material-icons/svg/svg/refresh/outline.svg?component'
import TIClear from '@material-icons/svg/svg/clear/outline.svg?component'
import TIDelete from '@material-icons/svg/svg/delete/outline.svg?component'
import TIDeleteForever from '@material-symbols/svg-700/rounded/delete_forever.svg?component'
import TIRemove from '@material-icons/svg/svg/remove/outline.svg?component'
import TIAdd from '@material-icons/svg/svg/add/outline.svg?component'
import TIEdit from '@material-icons/svg/svg/edit/outline.svg?component'
import TISave from '@material-icons/svg/svg/save/outline.svg?component'
import TIDragHandle from '@material-icons/svg/svg/drag_handle/outline.svg?component'
import TIDragIndicator from '@material-icons/svg/svg/drag_indicator/outline.svg?component'
import TIHistory from '@material-icons/svg/svg/history/outline.svg?component'
import TITaxi from '@material-icons/svg/svg/local_taxi/outline.svg?component'
import TITaxiList from '@material-icons/svg/svg/local_taxi/outline.svg?component'
import TITaxiDetail from '@material-icons/svg/svg/local_taxi/outline.svg?component'
import TITaxiOnDuty from '@material-icons/svg/svg/chevron_left/outline.svg?component'
import TITrue from '@material-icons/svg/svg/check_circle/baseline.svg?component'
import TIFalse from '@material-icons/svg/svg/cancel/baseline.svg?component'
import TIFace from '@material-icons/svg/svg/face/baseline.svg?component'
import TIFaceVerify from '@material-icons/svg/svg/how_to_reg/baseline.svg?component'
import TIWait from '@material-icons/svg/svg/hourglass_empty/baseline.svg?component'
import TIImageMissing from '@material-icons/svg/svg/image_not_supported/outline.svg?component'
import TIDarkModeToggle from '@material-icons/svg/svg/brightness_4/outline.svg?component'
import TILightMode from '@material-icons/svg/svg/light_mode/outline.svg?component'
import TIDarkMode from '@material-icons/svg/svg/dark_mode/outline.svg?component'
import TIArchived from '@material-icons/svg/svg/folder_copy/outline.svg?component'
import TIArchivedBack from '@material-icons/svg/svg/folder/outline.svg?component'
import TIArchive from '@material-icons/svg/svg/archive/outline.svg?component'
import TIUnArchive from '@material-icons/svg/svg/unarchive/outline.svg?component'
import TIExport from '@material-icons/svg/svg/folder_zip/outline.svg?component'
import TIDownload from '@material-icons/svg/svg/download/outline.svg?component'
import TIEmail from '@material-icons/svg/svg/email/outline.svg?component'
import TIPhone from '@material-icons/svg/svg/phone/outline.svg?component'
import TIAppointment from '@material-icons/svg/svg/calendar_today/outline.svg?component'
import TIWarning from '@material-icons/svg/svg/report_problem/outline.svg?component'
import TISend from '@material-icons/svg/svg/send/outline.svg?component'
import TICheckboxChecked from '@material-icons/svg/svg/check_box/outline.svg?component'
import TICheckboxUnchecked from '@material-icons/svg/svg/check_box_outline_blank/outline.svg?component'
import TIList from '@material-icons/svg/svg/list/outline.svg?component'
import TIHelp from '@material-icons/svg/svg/help_outline/outline.svg?component'
import TIInfo from '@material-icons/svg/svg/info/outline.svg?component'
import TIConfigureVoIPDevice from '@material-icons/svg/svg/dialer_sip/outline.svg?component'
import TIVoucher from '@material-icons/svg/svg/confirmation_number/outline.svg?component'
import TICashFree from '@material-icons/svg/svg/account_balance_wallet/outline.svg?component'
import TIGratis from '@material-icons/svg/svg/redeem/outline.svg?component'
import TIInvoice from '@material-icons/svg/svg/receipt_long/outline.svg?component'
import TILegalMinBase from '@material-icons/svg/svg/taxi_alert/outline.svg?component'
import TILegalBase from '@material-icons/svg/svg/local_taxi/outline.svg?component'
import TIDocs from '@material-icons/svg/svg/folder_shared/outline.svg?component'
import TIPassword from '@material-icons/svg/svg/lock/outline.svg?component'
import TIFeatures from '@material-icons/svg/svg/style/outline.svg?component'
import TITaxiGroup from '@material-icons/svg/svg/hub/outline.svg?component'
import TICallReceived from '@material-icons/svg/svg/call_received/baseline.svg?component'
import TICallMade from '@material-icons/svg/svg/call_made/baseline.svg?component'
import TICallMissed from '@material-icons/svg/svg/call_missed/baseline.svg?component'
import TIErrorOutline from '@material-icons/svg/svg/error/outline.svg?component'
import TIAlarm from '@material-icons/svg/svg/alarm/outline.svg?component'
import TIHome from '@material-icons/svg/svg/home/outline.svg?component'
import TISubscription from '@material-icons/svg/svg/date_range/outline.svg?component'
import TIVisible from '@material-icons/svg/svg/visibility/outline.svg?component'
import TIVisibleOff from '@material-icons/svg/svg/visibility_off/outline.svg?component'
import TIGeneratePassword from '@material-icons/svg/svg/lock_reset/outline.svg?component'
import TIPerson from '@material-icons/svg/svg/person/outline.svg?component'
import TILink from '@material-icons/svg/svg/link/outline.svg?component'
import TIPrivacy from '@material-icons/svg/svg/account_box/outline.svg?component'
import TIRegulations from '@material-icons/svg/svg/description/outline.svg?component'
import TISmartphone from '@material-icons/svg/svg/phone_android/outline.svg?component'
import TIStarOutline from '@material-icons/svg/svg/star_border/outline.svg?component'
import TIStar from '@material-icons/svg/svg/star/outline.svg?component'
import TITimer from '@material-icons/svg/svg/timer/outline.svg?component'
import TICelebration from '@material-icons/svg/svg/celebration/outline.svg?component'
import TIDestination from '@material-icons/svg/svg/where_to_vote/outline.svg?component'
import TIPickup from '@material-icons/svg/svg/person_pin_circle/outline.svg?component'
import TIPrice from '@material-icons/svg/svg/account_balance_wallet/outline.svg?component'
import TIETA from '@material-symbols/svg-700/rounded/share_eta.svg?component'
import TILocation from '@material-symbols/svg-700/rounded/my_location.svg?component'
import TILocationPin from '@material-icons/svg/svg/edit_location/outline.svg?component'
import TILocationDisabled from '@material-symbols/svg-700/rounded/location_disabled.svg?component'
import TILocateMe from '@material-symbols/svg-700/rounded/near_me.svg?component'
import TIPrepaidChange from '@material-symbols/svg-700/rounded/payment_arrow_down.svg?component'
import TIPrepaidChangeList from '@material-symbols/svg-700/rounded/payments.svg?component'
import TINote from '@material-symbols/svg-700/rounded/sticky_note_2.svg?component'
import TIOnTheWay from '@material-symbols/svg-700/rounded/turn_slight_right.svg?component'
import TIPersonCancel from '@material-symbols/svg-700/rounded/person_cancel.svg?component'
import TIDiscount from '@material-symbols/svg-700/rounded/featured_seasonal_and_gifts.svg?component'
import TIPoints from '@material-symbols/svg-700/rounded/savings.svg?component'
import TICopy from '@material-symbols/svg-700/rounded/content_copy.svg?component'
import TIConfig from '@material-icons/svg/svg/handyman/outline.svg?component'
import TIBroadcast from '@material-icons/svg/svg/campaign/outline.svg?component'
import TISms from '@material-symbols/svg-700/rounded/chat.svg?component'
import TISendSms from '@material-symbols/svg-700/rounded/add_comment.svg?component'
import TIBack from '@material-symbols/svg-700/rounded/arrow_back.svg?component'
import TILogin from '@material-icons/svg/svg/login/outline.svg?component'
import TIPlay from '@material-icons/svg/svg/play_arrow/outline.svg?component'
import TIFirst from '@material-icons/svg/svg/first_page/outline.svg?component'
import TILast from '@material-icons/svg/svg/last_page/outline.svg?component'
import TIRoute from '@material-icons/svg/svg/route/outline.svg?component'
import TISignal from '@material-symbols/svg-700/rounded/e911_emergency.svg?component'
import TIBlock from '@material-icons/svg/svg/block/outline.svg?component'
import TIFitEdit from '@material-icons/svg/svg/center_focus_strong/outline.svg?component'
import TIArrowUp from '@material-icons/svg/svg/straight/outline.svg?component'
import TIArrowTop from '@material-icons/svg/svg/vertical_align_top/outline.svg?component'
import TIArrowBottom from '@material-icons/svg/svg/vertical_align_bottom/outline.svg?component'
import TIBank from '@material-icons/svg/svg/account_balance/outline.svg?component'
import TIPayment from '@material-icons/svg/svg/payments/outline.svg?component'
import TICharge from '@material-icons/svg/svg/battery_charging_full/outline.svg?component'
import TIVerified from '@material-icons/svg/svg/verified/outline.svg?component'
import TIServer from '@material-icons/svg/svg/dns/outline.svg?component'
import TISync from '@material-icons/svg/svg/sync/outline.svg?component'
import TICoins from '@material-icons/svg/svg/toll/outline.svg?component'

// components
import IconYesNo from './components/icon/IconYesNo.vue';
import IconBool from './components/icon/IconBool.vue';
import IconLegalMin from './components/icon/IconLegalMin.vue'
import IconLegal from './components/icon/IconLegal.vue'

// export all
export default {
	// SVG icons
	TIFitAll,
	TINavPoints,
	TIZones,
	TITaxis,
	TIMap,
	TIMyGPS,
	TIArea,
	TIStreet,
	TIHouse,
	TIPOI,
	TIPOIInternal,
	TIMenu,
	TIMore,
	TISettings,
	TILogout,
	TISearch,
	TIClose,
	TICheck,
	TIChevronLeft,
	TIChevronRight,
	TIExpandLess,
	TIExpandMore,
	TIRefresh,
	TIClear,
	TIDelete,
	TIDeleteForever,
	TIRemove,
	TIAdd,
	TIEdit,
	TISave,
	TIDragHandle,
	TIDragIndicator,
	TIHistory,
	TITaxi,
	TITaxiList,
	TITaxiDetail,
	TITaxiOnDuty,
	TITrue,
	TIFalse,
	TIFace,
	TIFaceVerify,
	TIWait,
	TIImageMissing,
	TIDarkModeToggle,
	TILightMode,
	TIDarkMode,
	TIArchived,
	TIArchivedBack,
	TIArchive,
	TIUnArchive,
	TIExport,
	TIDownload,
	TIEmail,
	TIPhone,
	TIAppointment,
	TIWarning,
	TISend,
	TICheckboxChecked,
	TICheckboxUnchecked,
	TIList,
	TIHelp,
	TIInfo,
	TIConfigureVoIPDevice,
	TIVoucher,
	TICashFree,
	TIGratis,
	TIDiscount,
	TIInvoice,
	TILegalMinBase,
	TILegalBase,
	TIDocs,
	TIPassword,
	TIFeatures,
	TITaxiGroup,
	TICallReceived,
	TICallMade,
	TICallMissed,
	TIErrorOutline,
	TIAlarm,
	TIHome,
	TISubscription,
	TIVisible,
	TIVisibleOff,
	TIGeneratePassword,
	TIPerson,
	TILink,
	TIPrivacy,
	TIRegulations,
	TISmartphone,
	TIStar,
	TIStarOutline,
	TITimer,
	TICelebration,
	TIDestination,
	TIPickup,
	TIPrice,
	TIETA,
	TILocation,
	TILocationPin,
	TILocationDisabled,
	TILocateMe,
	TIPrepaidChange,
	TIPrepaidChangeList,
	TINote,
	TIOnTheWay,
	TIPersonCancel,
	TIPoints,
	TICopy,
	TIConfig,
	TIBroadcast,
	TISms,
	TISendSms,
	TIBack,
	TILogin,
	TIPlay,
	TIFirst,
	TILast,
	TIRoute,
	TISignal,
	TIBlock,
	TIFitEdit,
	TIArrowUp,
	TIArrowTop,
	TIArrowBottom,
	TIBank,
	TIPayment,
	TICharge,
	TIVerified,
	TIServer,
	TISync,
	TICoins,

	// components
	IconBool,
	IconYesNo,
	TILegalMin: IconLegalMin,
	TILegal: IconLegal,
};
